import { render, staticRenderFns } from "./SampleTypeAnalyteRangeAddForm.vue?vue&type=template&id=56587dad"
import script from "./SampleTypeAnalyteRangeAddForm.vue?vue&type=script&lang=js"
export * from "./SampleTypeAnalyteRangeAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports